// stylelint-disable declaration-no-important
// stylelint-disable no-descending-specificity
@import '../../style/index';

@include host {
  display: block;

  @include component-margin();

  rcm-column:first-child {
    @include large-up() {
      padding-right: var(--spacings-xl) !important;
    }
  }

  rcm-column:last-child {
    @include large-up() {
      padding-left: var(--spacings-xl) !important;
    }
  }

  .reverse {
    flex-direction: row-reverse;

    rcm-column:first-child {
      @include large-up() {
        padding-left: var(--spacings-xl) !important;
        padding-right: var(--columnGap) !important;
      }
    }

    rcm-column:last-child {
      @include large-up() {
        padding-right: var(--spacings-xl) !important;
        padding-left: var(--columnGap) !important;
      }
    }
  }

  .article-container {
    margin: 0;

    rcm-column {
      --columnGap: 0;

      @include medium-up() {
        --columnGap: var(--spacings-s);
      }
    }

    rcm-column:first-child {
      padding-right: var(--columnGap) !important;
      padding-left: var(--columnGap) !important;
    }

    rcm-column:last-child {
      padding-left: var(--columnGap) !important;
      padding-right: var(--columnGap) !important;
    }
  }

  .image-container {
    &--centered {
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: start;
      flex-direction: column;
    }
  }

  .text-container {
    display: flex;
    justify-content: center;
    align-items: start;
    flex-direction: column;

    p {
      @include copy-primary();
    }
  }

  .shadow {
    @include shadow-sm();
  }

  .link-container {
    display: flex;
    align-items: center;

    rcm-button {
      &:first-of-type {
        margin-right: var(--spacings-s);
      }
    }
  }
}
